import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClubSelectorComponent } from './club-selector.component';
import { FormsModule } from '@angular/forms';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';


@NgModule({
  declarations: [
    ClubSelectorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    FGBSharedModule
  ],
  exports:[
    ClubSelectorComponent
  ]
})
export class ClubSelectorModule { }
